import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { ModuleIsEnabledFilter } from '@gongxigames/framework/core';
import {
    PromotionTypes,
    isEnabledPromotionType,
    MultiSetsPromotionLogic,
    BasePromotionModule,
    MultiSetsPromotionStates,
    MultiSetsPromotionStatesMap,
} from '@gongxigames/framework/promotions';

export type MultiSetsPromotionModuleEvents = {
    'MultiSetsPromotion.START_STATE_LEFT': void;
} & GlobalEventsMapForBackwardCompatibility;

export class MultiSetsPromotionModule extends BasePromotionModule<MultiSetsPromotionModuleEvents> {
    public static readonly NAME: symbol = Symbol.for('MultiSetsPromotionModule');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledPromotionType(PromotionTypes.MultiSetsPromotion);

    protected setupStates(): void {
        this.addStates(MultiSetsPromotionStatesMap);
        this.gotoState(MultiSetsPromotionStates.INIT);
    }

    public endPromotion(): void {
        this.getPromotion<MultiSetsPromotionLogic>().end();
        this.getEventManager<GlobalEventsMapForBackwardCompatibility>().emit('General.Promotion.Campaign.Ended');

        if (this.getPromotion().hasPromotion()) {
            this.gotoState(MultiSetsPromotionStates.START);
        } else {
            this.gotoState(MultiSetsPromotionStates.BASIC);
            this.getEventManager<GlobalEventsMapForBackwardCompatibility>().emit('General.Promotion.Ended');
        }
    }
}
